"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function WhyConnectors() {
  const {
    ref: headerRef,
    isVisible: isHeaderVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section id="why-connectors" className="bg-background py-24 lg:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6 max-w-7xl">
        
        {}
        <div ref={headerRef} className={`text-center mb-16 md:mb-24 transition-all duration-1000 ease-out ${isHeaderVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-foreground tracking-tight">
            Why Work With Us?
          </h2>
        </div>

        {}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {}
          <div ref={imageRef} className={`relative lg:ml-auto lg:mr-0 w-full max-w-md lg:max-w-none transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0"}`}>
            {}
            <div className="absolute inset-0 bg-primary/10 rounded-[40%_60%_70%_30%/40%_50%_60%_50%] transform -rotate-6 scale-105 blur-2xl transition-transform duration-700 hover:scale-110 hover:rotate-0"></div>
            
            {}
            <div className="relative aspect-[4/5] w-full">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1589716/img/asian_female_founder_portrait.png" alt="Founder of Creative Connectors" className="w-full h-full object-cover rounded-[60%_40%_30%_70%/60%_30%_70%_40%] shadow-2xl transition-transform duration-700 hover:scale-[1.02]" />
            </div>
          </div>

          {}
          <div ref={textRef} className={`flex flex-col gap-8 transition-all duration-1000 delay-400 ease-out ${isTextVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-12"}`}>
            <div className="space-y-6 text-lg md:text-xl text-muted-foreground leading-relaxed font-sans">
              <p className="text-foreground font-semibold">
                Our approach works when everything else has failed
              </p>
              <p className="font-bold">Pillar 1: AI-Assisted Execution</p>
              <p>
                We leverage cutting‑edge AI tools to handle the heavy lifting—content drafts, research, distribution, optimization—so you don't have to spend hours creating from scratch. But here's the key: AI amplifies your voice, it doesn't replace it. Every piece of content still carries your authentic perspective and expertise.
              </p>
              <p className="!font-normal"><strong>Pillar 2: SME-Specific Strategy</strong> <br /><br />We've worked exclusively with SME founders for years. We understand your unique challenges: limited time, finite resources, the need for ROI, and the balance between serving clients and growing the business. Our strategy is built for real business owners, not corporate marketing departments..</p>
              <p className="!font-normal"><strong>Pillar 3: Human Coaching</strong> <br /><br />Strategy and AI provide the foundation, but human coaching provides the edge. We work 1-on-1 with you to refine your unique voice, overcome mental roadblocks, and ensure your authority is amplified with the authenticity that only a human partnership can provide.</p>
            </div>
          </div>

        </div>
      </div>
    </section>;
}